/*
 * 2016 sitegeist media solutions GmbH
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of sitegeist media solutions GmbH and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to sitegeist media solutions GmbH
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from sitegeist media solutions GmbH.
 *
 */

/** @jsx h */

import {h, render, Component} from 'preact';
import mergeClassnames from 'classnames';

export default class Pagination extends Component {
	render({current, total, label, onNavigatePrev, onNavigateNext}) {
		const prevHandle = current > 1 ? <a
			onClick={() => onNavigatePrev()}
			className="lightbox__gallery__pagination__handle lightbox__gallery__pagination__handle--prev"
			>&laquo;</a> : null;
		const nextHandle = current < total ? <a
			onClick={() => onNavigateNext()}
			className="lightbox__gallery__pagination__handle lightbox__gallery__pagination__handle--next"
			>&raquo;</a> : null;

		return (<div className="lightbox__gallery__pagination">
			{prevHandle}
			{label.replace('{current}', current).replace('{total}', total)}
			{nextHandle}
		</div>);
	}
}
